import { formatJSTTime } from 'src/replicant/utils/time';
import type { FateStateScheduleRecord } from './fate.schema';
import {
  FatePermanentStatusEffect,
  fatePermanentStatusEffects,
  FateState,
} from './fate.ruleset';

/**
 * Human readable fate state formatter
 */
export function fateToArray(fate: { [key: string]: FateStateScheduleRecord }) {
  return Object.keys(fate)
    .map((id) => ({ state: id, timestamp: fate[id].timestamp }))
    .sort((a, b) => a.timestamp - b.timestamp)
    .map((item) => ({
      state: item.state,
      date: formatJSTTime(item.timestamp),
    }));
}

/**
 * Human readable fate state formatter
 */
export function fateToString(fate: { [key: string]: FateStateScheduleRecord }) {
  const array = fateToArray(fate).map(
    (item) => `${item.date} - ${item.state.toUpperCase()}`,
  );

  return array.join('\n');
}

export const isPermanentStatusEffect = (
  status: FateState,
): status is FatePermanentStatusEffect =>
  fatePermanentStatusEffects.includes(status as FatePermanentStatusEffect);
